import axios, { AxiosResponse } from 'axios';
import apiPaths from 'enums/apiPaths';

export interface IBankID {
    typ: string;
    idzadosti?: string;
}

export interface IBankIDData {
    urlbankid: string;
    code?: number;
    message?: string;
}

const bankidApi = (typ: string, idzadosti?: string) => {
    return axios({
        method: 'POST',
        url: apiPaths.BANKID,
        data: {
            typ,
            idzadosti
        }
    }).then((resp: AxiosResponse<IBankIDData>) => resp.data);
};

export default bankidApi;
